/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useHookstate } from '@hookstate/core';
import StandardModal from '../../../../components/StandardModal';
import VideoMonitoringList from '../VideoMonitoringList';
import { useLang } from '../../../../hooks/useLang';
import MonochromePhotosIcon from '@mui/icons-material/MonochromePhotos';
import { useLocation } from 'react-router';
import useSystemState from '~/features/System/stores/SystemState';
import { storeScreenSettings } from '~/features/System/services';
import { authFetch } from '~/services/fetch';
import ScreenSettingsDraggableProps from '~/features/Entry/interfaces/IPositionDraggable';
import { Grid, Typography } from '@mui/material';
import useSurveillanceReportingState from '../../stores/SurveillanceReportingState';

const modal = document.getElementById('div-modal') as HTMLElement;

export default function VideoMonitoringModalDraggable() {
  const { translate } = useLang();
  const { windowManager, loadingButton } = useSystemState();
  const location = useLocation();
  const { surveillanceReportingStates } = useSurveillanceReportingState();
  const { rowsCount } = surveillanceReportingStates();
  const loadingComponent = useHookstate(true);

  const getPositionsDraggable = useHookstate<ScreenSettingsDraggableProps>({
    id: 0,
    user_id: 0,
    url: '',
    window_name: '',
    x_position: 1000,
    y_position: 300,
    is_window_open: true,
    is_window_minimized: false,
    created_at: new Date().toJSON(),
    updated_at: new Date().toJSON(),
    deleted_at: null
  });

  useEffect(() => {
    authFetch({
      url: '/screen-setting/get-user-settings',
      method: 'POST',
      data: {
        url: location.pathname,
      }
    }).then((response) => {
      if ('VideoMonitoringModalDraggable' in response.data) {
        getPositionsDraggable.set(response.data.VideoMonitoringModalDraggable);
      }
    }).finally(() => {
      loadingComponent.set(false);
    });

    return () => {
      windowManager()['videoMonitoring'].open.set(false);
    };
  }, []);

  const handleStop = (event, dragElement) => {
    event.stopPropagation();
    event.preventDefault();

    getPositionsDraggable.x_position.set(dragElement.x);
    getPositionsDraggable.y_position.set(dragElement.y);
  };

  useEffect(() => {
    return () => {
      storeScreenSettings({
        windowName: 'VideoMonitoringModalDraggable',
        isOpen: windowManager()['videoMonitoring'].open.get(),
        isMinimized: getPositionsDraggable.is_window_minimized?.get(),
        positionX: getPositionsDraggable?.x_position?.get(),
        positionY: getPositionsDraggable?.y_position?.get(),
      });
    };
  }, [
    windowManager()['videoMonitoring'].open.get(),
    getPositionsDraggable.is_window_minimized?.get(),
    getPositionsDraggable?.x_position?.get(),
    getPositionsDraggable?.y_position?.get(),
  ]);

  const shouldRender = 
    windowManager()['videoMonitoring'].open.value && 
    location.pathname === '/video-monitoring' && 
    !loadingButton.value && 
    !loadingComponent.value;

  return ReactDOM.createPortal(
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {shouldRender && (
        <StandardModal
          title={
            <Grid
              container
              sx={{
                flexDirection: 'row',
                alignItems: 'start',
                textAlign: 'start',
              }}
            >
              <Grid item sx={{ alignSelf: 'start', marginRight: 'auto' }}>
                <Typography>
                  {translate('List of reports')}
                </Typography>
                <Typography variant="subtitle2" color={'text.secondary'}>
                  {`Total: ${rowsCount.get()}`}
                </Typography>
              </Grid>
            </Grid>
          }
          avatar={MonochromePhotosIcon}
          dimensions={{ width: 800 }}
          handleStop={handleStop}
          isExpanded={getPositionsDraggable.is_window_minimized}
            position={{
              x: getPositionsDraggable?.x_position?.get() ? Number(getPositionsDraggable?.x_position?.get()) : 1000, // eslint-disable-line id-length
              y: getPositionsDraggable?.y_position?.get() ? Number(getPositionsDraggable?.y_position?.get()) : 300 // eslint-disable-line id-length
            }}
          closeButton={false}
          variant={'h5'}
        >
          <VideoMonitoringList />
        </StandardModal>
      )}
    </>,
    modal
  );
}
